/*
  Studio Pro By Charlot · le questionnaire de demande de devis (/pages/cadeau-entreprise).

  Les donnees (plantes, pots, photos de reference, adresse du script de reception)
  sont posees par la section Liquid dans <script id="sp-donnees">. Les modules
  StudioAdresses et StudioEtiquette sont charges juste avant ce fichier ; SheetJS
  (lecture des fichiers Excel, 1 Mo) n'est charge qu'au depot d'un fichier.

  Rien n'est bloquant pour le client, sauf ses coordonnees (societe, nom, email).
*/
(function () {
  "use strict";
  const racine = document.getElementById("studio-pro");
  if (!racine) return;
  const DON = JSON.parse(document.getElementById("sp-donnees").textContent);
  const CAT = { plantes: DON.plantes.filter(Boolean), pots: DON.pots.filter(Boolean) };
  const TAILLES = [ { t: "XS", nom: "Petites", detail: "pot ⌀ 8 cm" }, { t: "S", nom: "Moyennes", detail: "± 20 à 30 cm · pot ⌀ 10 cm" }, { t: "M", nom: "Grandes", detail: "± 50 cm · pot ⌀ 15 cm" } ]
    .filter(x => CAT.plantes.some(p => p.t === x.t) && CAT.pots.some(p => p.t === x.t));
  const A = window.StudioAdresses, E = window.StudioEtiquette;
  const $ = s => racine.querySelector(s), $$ = s => racine.querySelectorAll(s);
  const echapper = s => String(s == null ? "" : s).replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  const CLE = "studio-pro-demande";
  const AUTO = ["occasion", "quantite"];
  const debut = Date.now();

  // ------------------------------------------------ animations facon Apple : apparitions au defilement et profondeur des photos.
  // Rien ne bouge si le visiteur a demande moins de mouvement ; sans script, tout reste visible.
  (() => {
    const calme = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (calme || !("IntersectionObserver" in window)) return;
    racine.classList.add("sp-anim");
    const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add("vu"); io.unobserve(e.target); } }),
                                        { threshold: .12, rootMargin: "0px 0px -6% 0px" });
    racine.querySelectorAll("[data-reveal], [data-reveal-groupe]").forEach(el => io.observe(el));
    // la propriete « translate » se compose avec les « transform » des animations CSS sans les ecraser
    const couches = [...racine.querySelectorAll("[data-parallax]")];
    let prevu = false;
    const bouger = () => {
      prevu = false;
      const h = window.innerHeight;
      couches.forEach(el => {
        const r = el.parentElement.getBoundingClientRect();
        if (r.bottom < -200 || r.top > h + 200) return;
        const y = Math.max(-140, Math.min(140, (h / 2 - (r.top + r.height / 2)) * parseFloat(el.dataset.parallax || 0)));
        el.style.translate = `0 ${y.toFixed(1)}px`;
      });
    };
    window.addEventListener("scroll", () => { if (!prevu) { prevu = true; requestAnimationFrame(bouger); } }, { passive: true });
    window.addEventListener("resize", bouger, { passive: true });
    bouger();
  })();

  // ------------------------------------------------ photos de reference : la plante et le pot se lisent dans le nom du fichier
  // « Philosophe_OleaEuropaea_By_Charlot_S-PHI-CPIN10.jpg » : plante S-PHI, pot S-CPIN10
  const REF = {};
  Object.entries(DON.ref || {}).forEach(([t, r]) => {
    if (!r || !r.photo) return;
    const m = decodeURIComponent(r.photo).match(/_((?:XXS|XS|S|M|L|XL))-([A-Z0-9]+)-([A-Z0-9]+)\.(?:jpe?g|png|webp)/i);
    REF[t] = { photo: r.photo, skuPlante: r.skuPlante || (m ? `${m[1]}-${m[2]}` : ""), skuPot: r.skuPot || (m ? `${m[1]}-${m[3]}` : "") };
  });

  // ------------------------------------------------ prix « des » par taille : plante + pot le moins cher, HT, arrondi en dessous
  const desPrix = t => {
    const pl = CAT.plantes.filter(p => p.t === t).map(p => p.prix), po = CAT.pots.filter(p => p.t === t).map(p => p.prix);
    return pl.length && po.length ? Math.floor(Math.min(...pl) / 1.2 + Math.min(...po) / 1.2) : null;
  };

  // ------------------------------------------------ familles de teintes des pots (une couleur unie se montre sur un pot uni)
  const MOTIFS = /l[ée]opard|z[ée]br|mosa|quadrill|marbr|jaspe|spirale|ray[ée]|cannel/i;
  const FAMILLES = [
    ["Noir", /noir|onyx|graphite|night/i], ["Blanc et beige", /blanc|beige|sable|ivoire|snow/i], ["Bleu", /bleu|turquoise|lazuli|oc[ée]an|maldive|olympe|ceylan|marine|saphir|cyclade/i],
    ["Vert", /vert|amazonite|verde|toscane|c[ée]ladon/i], ["Rose et rouge", /rose|rouge|carmin|bordeaux|sorbet|cassis|p[êe]che|canyon|rosso|terra|ambre/i],
    ["Métal", /cuivre|argent|laiton|nickel/i], ["Motifs", /l[ée]opard|z[ée]br|mosa|quadrill/i]
  ].map(([nom, re]) => ({ nom, pot: CAT.pots.filter(p => re.test(p.nom) && (nom === "Motifs" || !MOTIFS.test(p.nom))).sort((a, b) => b.stock - a.stock)[0] })).filter(f => f.pot);

  // ------------------------------------------------ les pictogrammes se dessinent quand ils arrivent a l'ecran
  (() => {
    const z = $("#sp-pictos");
    if (!z || !("IntersectionObserver" in window) || (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches)) return;
    z.classList.add("pret");
    // chaque pictogramme est suivi a part ; ceux qui entrent ensemble a l'ecran partent l'un apres l'autre.
    // L'animation se rejoue a chaque passage : un pictogramme sorti de l'ecran se remet en position de depart.
    const o = new IntersectionObserver(es => {
      es.filter(e => !e.isIntersecting).forEach(e => { e.target.classList.remove("vu"); e.target.style.removeProperty("--r"); });
      es.filter(e => e.isIntersecting && e.intersectionRatio >= .35 && !e.target.classList.contains("vu"))
        .sort((a, b) => a.target.style.getPropertyValue("--i") - b.target.style.getPropertyValue("--i"))
        .forEach((e, k) => { e.target.style.setProperty("--r", `${k * .18}s`); e.target.classList.add("vu"); });
    }, { threshold: [0, .35] });
    z.querySelectorAll(".picto").forEach(p => o.observe(p));
  })();

  // ------------------------------------------------ realisations : sur telephone, un carrousel a faire glisser, avec des points
  (() => {
    const m = racine.querySelector(".mosaique");
    if (!m || !m.children.length) return;
    const points = document.createElement("div");
    points.className = "points"; points.setAttribute("aria-hidden", "true");
    points.innerHTML = [...m.children].map(() => "<i></i>").join("");
    m.after(points);
    let prevu = false;
    const maj = () => {
      prevu = false;
      const centre = m.scrollLeft + m.clientWidth / 2;
      let i = 0, ecart = Infinity;
      [...m.children].forEach((f, k) => { const d = Math.abs(f.offsetLeft + f.offsetWidth / 2 - centre); if (d < ecart) { ecart = d; i = k; } });
      points.querySelectorAll("i").forEach((p, k) => p.classList.toggle("actif", k === i));
    };
    m.addEventListener("scroll", () => { if (!prevu) { prevu = true; requestAnimationFrame(maj); } }, { passive: true });
    maj();
  })();

  // ------------------------------------------------ le bouton flottant : visible une fois le haut de page passe, cache sur le questionnaire
  (() => {
    const cta = $("#cta-flottant"), hero = racine.querySelector(".hero"), demande = $("#demande");
    if (!cta || !hero || !demande || !("IntersectionObserver" in window)) return;
    let apresHero = false, surDemande = false;
    const maj = () => cta.classList.toggle("montre", apresHero && !surDemande);
    new IntersectionObserver(e => { apresHero = !e[0].isIntersecting; maj(); }).observe(hero);
    new IntersectionObserver(e => { surDemande = e[0].isIntersecting; maj(); }, { threshold: .05 }).observe(demande);
  })();

  // ------------------------------------------------ les reponses (gardees dans le navigateur : un rechargement ne perd rien)
  // une demande commencee est gardee 7 jours dans le navigateur, puis repart de zero
  const SEPT_JOURS = 7 * 24 * 3600 * 1000;
  let R = {};
  try { R = JSON.parse(localStorage.getItem(CLE) || "{}") || {}; } catch (e) { R = {}; }
  if (R.majLe && Date.now() - R.majLe > SEPT_JOURS) R = {};
  const repriseEnCours = Object.keys(R).some(k => !["etape", "majLe"].includes(k) && R[k] !== null && R[k] !== "" && !(Array.isArray(R[k]) && !R[k].length));
  const garder = () => { try { R.majLe = Date.now(); localStorage.setItem(CLE, JSON.stringify(R)); } catch (e) {} };

  // ------------------------------------------------ cartes des tailles, des plantes et des teintes
  $("#tailles").innerHTML = TAILLES.map(x => `<button type="button" data-v="${x.t}">${REF[x.t] ? `<img src="${REF[x.t].photo}" alt="${x.nom}" loading="lazy">` : ""}<span class="l"><b>${x.nom}</b><small>${x.detail}${desPrix(x.t) ? ` · dès ${desPrix(x.t)} € HT` : ""}</small></span></button>`).join("");
  $("#familles").innerHTML = FAMILLES.map(f => `<button type="button" data-v="${f.nom}"><img src="${f.pot.img}" alt="${f.nom}" loading="lazy"><span class="l">${f.nom}</span></button>`).join("");
  function rendrePlantes() {
    const tailles = R.tailles && R.tailles.length ? R.tailles : TAILLES.map(x => x.t);
    const vus = new Set();
    const liste = CAT.plantes.filter(p => tailles.includes(p.t)).filter(p => !vus.has(p.nom) && vus.add(p.nom));
    $("#vignettes").innerHTML = liste.slice(0, 4).map(p => `<img src="${p.img}" alt="" loading="lazy">`).join("");
    $("#plantes-liste").innerHTML = liste.map(p => `<button type="button" data-v="${echapper(p.nom)}"><img src="${p.img}" alt="${echapper(p.nom)}" loading="lazy"><span class="l"><b>${echapper(p.nom)}</b></span></button>`).join("");
    brancherChoix($("#plantes-liste"));
  }

  // ------------------------------------------------ un bouton de choix : simple ou multiple, avec « Autre » qui ouvre un champ libre
  function brancherChoix(zone) {
    const champ = zone.dataset.champ, multi = !!zone.dataset.multi;
    const boutons = zone.querySelectorAll("button[data-v]");
    const marquer = () => boutons.forEach(b => b.setAttribute("aria-pressed", multi ? String((R[champ] || []).includes(b.dataset.v)) : String(R[champ] === b.dataset.v)));
    boutons.forEach(b => b.onclick = () => {
      const v = b.dataset.v;
      if (multi) { const l = new Set(R[champ] || []); l.has(v) ? l.delete(v) : l.add(v); R[champ] = [...l]; }
      else R[champ] = R[champ] === v ? null : v;          // un second clic deselectionne : rien n'est impose
      marquer(); apresChoix(champ); garder();
      // occasion et nombre de cadeaux : un clic suffit, on passe a la question suivante
      // (sauf « Autre », qui ouvre un champ a remplir, et sauf un second clic qui deselectionne)
      if (AUTO.includes(champ) && R[champ] === v && v !== "Autre") {
        const ici = etape;
        setTimeout(() => { if (etape === ici) { aller(etape + 1); haut(); } }, 380);
      }
    });
    marquer();
  }
  $$("[data-champ]").forEach(brancherChoix);
  const CHAMPS = ["occasionAutre", "quantiteExacte", "plantesAutre", "potsAutre", "etiquetteAutre", "titre", "sousTitre", "mot", "livraisonAutre", "cp", "ville", "sites", "date",
                  "budgetAutre", "societe", "nom", "email", "telephone", "message", "sourceAutre"];
  CHAMPS.forEach(id => { const el = racine.querySelector("#" + id); if (!el) return; if (R[id] != null) el.value = R[id]; el.addEventListener("input", () => { R[id] = el.value; garder(); apresChoix(id); }); });
  ["parDestinataire", "fichierPlusTard", "pasDeDate"].forEach(id => { const el = racine.querySelector("#" + id); el.checked = !!R[id]; el.onchange = () => { R[id] = el.checked; garder(); apresChoix(id); }; });

  function apresChoix(champ) {
    $$(".autre-champ").forEach(z => z.classList.toggle("montre", R[z.dataset.pour] === "Autre"));
    const q = parseInt(R.quantiteExacte, 10);
    $("#moins-de-10").hidden = !(q > 0 && q < 10);
    if (champ === "tailles") { rendrePlantes(); majVitrineTailles(); }
    if (champ === "etiquetteType") majAtelier();
    if (champ === "plantesMode" && ["Une même plante pour tous", "Un mix de plantes"].includes(R.plantesMode)) $("#coups-plantes").open = true;
    if (["titre", "sousTitre", "etiquetteType", "tailles"].includes(champ)) programmerBAT();
    if (champ === "livraisonMode") majLivraison();
    if (champ === "pasDeDate") $("#date").disabled = !!R.pasDeDate;
  }

  // ------------------------------------------------ l'etiquette et son bon a tirer (rendu par l'outil d'impression)
  const bat = { empreinte: null, logoURL: null, logoNom: "", logoFichier: null, taille: null, jeton: 0, dernier: null };
  function majAtelier() {
    const t = R.etiquetteType;
    $("#atelier").style.display = ["logo-titre", "logo-texte", "logo", "texte"].includes(t) ? "" : "none";
    $("#c-titre").style.display = ["logo-titre", "texte"].includes(t) ? "" : "none";
    $("#c-sous").style.display = ["logo-texte", "texte"].includes(t) ? "" : "none";
    $("#l-sous").textContent = t === "logo-texte" ? "Petit texte sous le logo" : "Sous-titre";
    $("#c-logo").style.display = /^logo/.test(t || "") ? "" : "none";
  }
  function majVitrineTailles() {
    const avecRef = TAILLES.filter(x => REF[x.t]);
    const dispo = R.tailles && R.tailles.length ? avecRef.filter(x => R.tailles.includes(x.t)) : avecRef;
    const liste = dispo.length ? dispo : avecRef;
    if (!liste.length) { $("#vitrine").style.display = "none"; return; }
    if (!bat.taille || !liste.some(x => x.t === bat.taille)) bat.taille = (liste.find(x => x.t === "S") || liste[0]).t;
    $("#v-tailles").innerHTML = liste.map(x => `<button type="button" data-t="${x.t}" aria-pressed="${x.t === bat.taille}">${x.nom}</button>`).join("");
    $$("#v-tailles button").forEach(b => b.onclick = () => { bat.taille = b.dataset.t; majVitrineTailles(); programmerBAT(0); });
    $("#v-photo").src = REF[bat.taille].photo;
  }
  $("#logo-fichier").onchange = async e => {
    const f = e.target.files[0]; if (!f) return;
    e.target.value = "";
    const note = $("#logo-note"), zone = $("#logo-depot");
    if (!/^image\/(png|jpeg)$/.test(f.type)) { note.className = "note alerte"; note.textContent = "Format non pris en charge : envoyez votre logo en PNG ou en JPEG. Sinon, joignez-le simplement en répondant à notre email."; return; }
    if (f.size > 15 * 1024 * 1024) { note.className = "note alerte"; note.textContent = "Fichier trop lourd : 15 Mo au maximum."; return; }
    zone.innerHTML = `<b>${echapper(f.name)}</b><br>Préparation…`;
    bat.logoURL = URL.createObjectURL(f); bat.logoNom = f.name; bat.logoFichier = f; bat.empreinte = null;
    try {
      const d = await E.deposerLogo(f);
      bat.empreinte = d.empreinte;
      note.className = "note" + (d.petit ? " alerte" : "");
      note.textContent = d.petit ? `Logo de petite taille (${d.largeur} × ${d.hauteur} px) : il risque d'être flou à l'impression. Une version plus grande est préférable.` : "";
    } catch (err) {
      note.className = "note alerte";
      note.textContent = err && err.message === "illisible" ? "Image illisible : essayez une autre version de votre logo." : "L'aperçu n'est pas disponible pour le moment. Votre logo partira avec la demande et nous vous enverrons le bon à tirer.";
    }
    zone.innerHTML = `<b>${echapper(f.name)}</b><br>Cliquer pour changer de logo`;
    programmerBAT(0);
  };
  // le zoom se cale sur l'etiquette : on repere sa place dans le calque (pixels opaques)
  function centrerZoom(img) {
    try {
      const c = document.createElement("canvas"), l = 200, h = Math.round(200 * img.naturalHeight / img.naturalWidth);
      c.width = l; c.height = h; const x = c.getContext("2d"); x.drawImage(img, 0, 0, l, h);
      const d = x.getImageData(0, 0, l, h).data; let x0 = l, y0 = h, x1 = -1, y1 = -1;
      for (let y = 0; y < h; y++) for (let i = 0; i < l; i++) if (d[(y * l + i) * 4 + 3] > 60) { x0 = Math.min(x0, i); x1 = Math.max(x1, i); y0 = Math.min(y0, y); y1 = Math.max(y1, y); }
      if (x1 < 0) return;
      const s = $("#v-scene");
      s.style.setProperty("--ox", `${((x0 + x1) / 2 / l * 100).toFixed(1)}%`); s.style.setProperty("--oy", `${((y0 + y1) / 2 / h * 100).toFixed(1)}%`);
      $("#v-zoom").hidden = false;
    } catch (e) { $("#v-zoom").hidden = true; }
  }
  $("#v-zoom").onclick = () => { const s = $("#v-scene"); s.classList.toggle("zoom"); $("#v-zoom").textContent = s.classList.contains("zoom") ? "Voir la plante entière" : "Zoom sur l'étiquette"; };

  let minuteur = null;
  function programmerBAT(delai) { clearTimeout(minuteur); minuteur = setTimeout(majBAT, delai == null ? 600 : delai); }
  async function majBAT() {
    const t = R.etiquetteType, jeton = ++bat.jeton;
    const calque = $("#v-calque"), attente = $("#v-attente"), note = $("#bat-note");
    note.textContent = ""; note.className = "note";
    if (!["logo-titre", "logo-texte", "logo", "texte"].includes(t) || !REF[bat.taille]) return;
    const titre = ["logo-titre", "texte"].includes(t) ? ($("#titre").value || "").trim() : "";
    const sous = ["logo-texte", "texte"].includes(t) ? ($("#sousTitre").value || "").trim() : "";
    if (/^logo/.test(t) && !bat.empreinte) { calque.hidden = true; attente.textContent = bat.logoURL ? "Aperçu indisponible" : "Déposez votre logo pour le voir ici"; return; }
    if (t === "texte" && !titre && !sous) { calque.hidden = true; attente.textContent = "Écrivez votre texte pour le voir ici"; return; }
    // l'etiquette precedente reste pleinement visible pendant la mise en page : jamais de transparence,
    // sinon l'etiquette d'origine de la photo apparait dessous
    attente.textContent = "Mise en page…";
    const ref = REF[bat.taille];
    try {
      const r = await E.calque({ taille: bat.taille, titre, sousTitre: sous, empreinte: bat.empreinte, type: t, skuPlante: ref.skuPlante, skuPot: ref.skuPot });
      if (jeton !== bat.jeton) return;
      await new Promise(ok => { calque.onload = calque.onerror = () => ok(); calque.src = r.url; if (calque.complete && calque.naturalWidth) ok(); });
      if (jeton !== bat.jeton) return;
      if (!calque.naturalWidth) throw new Error("calque non charge");
      calque.hidden = false; attente.textContent = "";
      centrerZoom(calque);
      bat.dernier = Object.assign({ taille: bat.taille, photo: ref.photo }, r);
      const coupes = [];
      if (r.titreCoupe) coupes.push(`le titre sera imprimé « ${r.titreImprime} »`);
      if (r.sousTitreCoupe) coupes.push(`le texte sera imprimé « ${r.sousTitreImprime} »`);
      if (coupes.length) { note.className = "note alerte"; note.textContent = `Trop long pour cette taille d'étiquette : ${coupes.join(", ")}. Raccourcissez-le si besoin.`; }
    } catch (err) {
      if (jeton !== bat.jeton) return;
      calque.hidden = true; attente.textContent = "";
      note.textContent = "L'aperçu n'est pas disponible pour le moment. Vos textes et votre logo partent avec la demande, nous vous enverrons le bon à tirer.";
    }
  }

  // ------------------------------------------------ livraison et fichier des destinataires
  let promesseXLSX = null;
  const chargerXLSX = () => promesseXLSX || (promesseXLSX = new Promise((ok, ko) => {
    if (window.XLSX) return ok(window.XLSX);
    const s = document.createElement("script"); s.src = DON.xlsx; s.async = true;
    s.onload = () => window.XLSX ? ok(window.XLSX) : ko(new Error("xlsx")); s.onerror = () => { promesseXLSX = null; ko(new Error("xlsx")); };
    document.head.appendChild(s);
  }));
  const adr = { res: null, nom: "", fichier: null };
  function majLivraison() {
    const m = R.livraisonMode;
    $("#l-une").hidden = m !== "Tout à une adresse";
    $("#l-sites").hidden = m !== "Sur quelques sites";
    $("#l-dest").hidden = m !== "Chez chaque destinataire";
  }
  $("#adr-fichier").onchange = async e => {
    const f = e.target.files[0]; if (!f) return;
    e.target.value = "";
    $("#adr-depot").innerHTML = `<b>${echapper(f.name)}</b><br>Vérification…`;
    let res;
    try { const X = await chargerXLSX(); res = A.lire(new Uint8Array(await f.arrayBuffer()), f.name, X); }
    catch (err) { res = { ok: false, fatal: err && err.message === "xlsx" ? "La vérification n'est pas disponible pour le moment. Vous pourrez nous envoyer le fichier en répondant à notre email." : "Fichier illisible. Enregistrez-le au format Excel (.xlsx) ou CSV, puis réessayez." }; }
    adr.res = res.ok ? res : null; adr.nom = f.name; adr.fichier = res.ok ? f : null;
    $("#adr-depot").innerHTML = `<b>${echapper(f.name)}</b><br>Cliquer pour déposer une version corrigée`;
    afficherAdresses(res);
  };
  function afficherAdresses(res) {
    const z = $("#adr-resultat");
    if (!res) { z.innerHTML = ""; return; }
    if (!res.ok) { z.innerHTML = `<div class="fichier-resume ko"><b>Fichier non pris en compte.</b> ${echapper(res.fatal)}</div>`; return; }
    const pb = res.lignes.filter(l => l.erreurs.length || l.alertes.length), prets = res.envois - res.nbErreurs;
    let h = `<div class="fichier-resume ${res.nbErreurs ? "" : "ok"}"><b>${res.envois} destinataire${res.envois > 1 ? "s" : ""}</b> · ${prets} prêt${prets > 1 ? "s" : ""}`
      + (res.nbErreurs ? ` · <span class="rouge">${res.nbErreurs} à corriger</span>` : "") + (res.nbAlertes ? ` · ${res.nbAlertes} à vérifier` : "")
      + ` · <button type="button" class="lien" id="adr-retirer">Retirer</button></div>`;
    if (pb.length) h += `<div class="table-scroll"><table class="erreurs"><thead><tr><th>Ligne</th><th>Destinataire</th><th>À revoir</th></tr></thead><tbody>`
      + pb.slice(0, 60).map(l => { const v = l.valeurs; return `<tr class="${l.erreurs.length ? "err" : "alr"}"><td>${l.numero}</td><td>${echapper((v.prenom + " " + v.nom).trim() || v.societe || "?")}</td><td>${echapper(l.erreurs.concat(l.alertes).join(" · "))}</td></tr>`; }).join("")
      + `</tbody></table></div><p class="note">Vous pouvez envoyer votre demande tel quel : nous corrigerons ensemble avant l'expédition.</p>`;
    z.innerHTML = h;
    $("#adr-retirer").onclick = () => { adr.res = null; adr.fichier = null; $("#adr-depot").innerHTML = `<b>Déposer votre fichier</b><br>Excel ou CSV, une ligne par colis`; afficherAdresses(null); };
  }

  // ------------------------------------------------ le recapitulatif : le meme texte part dans le mail de l'equipe
  const LIB_ETIQ = { "logo-titre": "Logo et titre", "logo-texte": "Logo et petit texte", "logo": "Logo seul", "texte": "Texte seul", "aucune": "Sans personnalisation" };
  const val = (champ, autre) => R[champ] === "Autre" ? `Autre : ${R[autre] || "(non précisé)"}` : (R[champ] || "");
  const dateFr = d => new Date(d + "T12:00").toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" });
  function resume() {
    const nomsTailles = (R.tailles || []).map(t => (TAILLES.find(x => x.t === t) || {}).nom).filter(Boolean).join(", ");
    const etiq = R.etiquetteType === "Autre" ? `Autre : ${R.etiquetteAutre || ""}` : (LIB_ETIQ[R.etiquetteType] || "");
    const detailsEtiq = [["logo-titre", "texte"].includes(R.etiquetteType) && R.titre ? `Titre : « ${R.titre} »` : "",
                         ["logo-texte", "texte"].includes(R.etiquetteType) && R.sousTitre ? `${R.etiquetteType === "texte" ? "Sous-titre" : "Petit texte"} : « ${R.sousTitre} »` : "",
                         /^logo/.test(R.etiquetteType || "") ? (bat.logoNom ? `Logo : ${bat.logoNom}` : "Logo : à envoyer") : "",
                         R.parDestinataire ? "Un texte différent par destinataire" : ""].filter(Boolean).join("\n");
    let livraison = val("livraisonMode", "livraisonAutre");
    if (R.livraisonMode === "Tout à une adresse" && (R.cp || R.ville)) livraison += ` · ${[R.cp, R.ville].filter(Boolean).join(" ")}`;
    if (R.livraisonMode === "Sur quelques sites" && R.sites) livraison += `\n${R.sites}`;
    if (R.livraisonMode === "Chez chaque destinataire") livraison += adr.res ? `\nFichier : ${adr.res.envois} destinataires (${adr.res.nbErreurs} à corriger)` : R.fichierPlusTard ? "\nListe envoyée plus tard" : "\nPas encore de fichier";
    const date = R.pasDeDate ? "Pas de date précise" : R.date ? dateFr(R.date) : "";
    return [
      ["occasion", "Occasion", val("occasion", "occasionAutre")],
      ["quantite", "Nombre de cadeaux", [R.quantite, R.quantiteExacte ? `${R.quantiteExacte} exactement` : ""].filter(Boolean).join(" · ")],
      ["plantes", "Plantes", [val("plantesMode", "plantesAutre"), nomsTailles ? `Tailles : ${nomsTailles}` : "", (R.plantesChoisies || []).length ? `Coups de cœur : ${R.plantesChoisies.join(", ")}` : ""].filter(Boolean).join("\n")],
      ["pots", "Pots", [val("potsMode", "potsAutre"), (R.teintes || []).length ? `Teintes : ${R.teintes.join(", ")}` : ""].filter(Boolean).join("\n")],
      ["etiquette", "Étiquette", [etiq, detailsEtiq, R.mot ? `Mot dans le colis : « ${R.mot} »` : ""].filter(Boolean).join("\n")],
      ["livraison", "Livraison", [livraison, date ? `Souhaitée : ${date}` : ""].filter(Boolean).join("\n")],
      ["coordonnees", "Contact", [R.societe, R.nom, R.email, R.telephone].filter(Boolean).join("\n")],
      ["coordonnees", "Message", R.message || ""],
      ["coordonnees", "Nous a connus par", val("source", "sourceAutre")]
    ];
  }
  // estimation indicative par cadeau : plante + pot HT, etiquette, remise selon la quantite (jamais un prix au centime)
  function tauxRemise() {
    const q = parseInt(R.quantiteExacte, 10);
    if (q > 0) return q >= 100 ? 25 : q >= 50 ? 20 : q >= 25 ? 15 : q >= 10 ? 10 : 0;
    return { "10 à 25": 10, "25 à 50": 15, "50 à 100": 20, "100 à 300": 25, "Plus de 300": 25 }[R.quantite] || 0;
  }
  function estimation() {
    const tailles = R.tailles && R.tailles.length ? R.tailles : TAILLES.map(x => x.t);
    let mini = Infinity, maxi = 0;
    tailles.forEach(t => {
      const pl = CAT.plantes.filter(p => p.t === t).map(p => p.prix), po = CAT.pots.filter(p => p.t === t).map(p => p.prix);
      if (!pl.length || !po.length) return;
      mini = Math.min(mini, Math.min(...pl) + Math.min(...po)); maxi = Math.max(maxi, Math.max(...pl) + Math.max(...po));
    });
    if (!isFinite(mini)) return null;
    const etiq = ["logo-titre", "logo-texte", "logo", "texte"].includes(R.etiquetteType) ? 4.17 : 0, taux = tauxRemise(), f = 1 - taux / 100;
    const bas = Math.floor((mini / 1.2 + etiq) * f), hautP = Math.ceil((maxi / 1.2 + etiq) * f);
    const texte = bas === hautP ? `environ ${bas} € HT par cadeau` : `entre ${bas} et ${hautP} € HT par cadeau`;
    const precision = ["Estimation indicative", taux ? `remise de ${taux} % comprise` : "", etiq ? "étiquette comprise" : "", "livraison en sus"].filter(Boolean).join(", ");
    return { texte, precision };
  }
  function rendreRecap() {
    const est = estimation(), z = $("#estimation");
    z.hidden = !est;
    if (est) z.innerHTML = `<b>${est.texte}</b><span>${est.precision}. Votre devis précis suit sous 24 à 48\u00a0h ouvrées.</span>`;
    $("#recap").innerHTML = resume().map(([q, t, v]) => `<div class="recap-ligne"><span class="t">${t}</span><span class="v">${v ? echapper(v) : '<span style="color:var(--pale)">Non précisé</span>'}</span><button type="button" class="lien" data-aller="${q}">Modifier</button></div>`).join("");
    $$("#recap [data-aller]").forEach(b => b.onclick = () => aller(ORDRE.indexOf(b.dataset.aller)));
  }

  // ------------------------------------------------ navigation
  const ORDRE = [...$$(".question")].map(q => q.dataset.q);
  let etape = Math.min(Math.max(0, R.etape || 0), ORDRE.indexOf("recap"));
  function aller(n) {
    etape = Math.max(0, Math.min(n, ORDRE.length - 1));
    const nom = ORDRE[etape];
    $$(".question").forEach(q => q.classList.toggle("active", q.dataset.q === nom));
    const total = ORDRE.indexOf("recap");
    $("#prog").style.width = `${Math.min(100, (etape / total) * 100)}%`;
    $("#prog-t").textContent = nom === "merci" ? "Envoyé" : nom === "recap" ? "Dernière vérification" : `Question ${etape + 1} sur ${total}`;
    $("#retour").style.visibility = etape === 0 || nom === "merci" ? "hidden" : "visible";
    $("#nav-q").style.display = nom === "merci" ? "none" : "";
    $("#suivant").textContent = nom === "recap" ? "Envoyer ma demande" : nom === "coordonnees" ? "Vérifier ma demande" : "Continuer";
    $("#envoi-erreur").hidden = true;
    if (nom === "etiquette") { majAtelier(); majVitrineTailles(); programmerBAT(0); }
    if (nom === "livraison") majLivraison();
    if (nom === "recap") rendreRecap();
    if (nom !== "merci") { R.etape = etape; garder(); }
  }
  function coordonneesValides(focaliser) {
    let ok = true;
    const verif = (id, cond) => { const c = $("#c-" + id); c.classList.toggle("erreur", !cond); if (!cond && ok && focaliser) $("#" + id).focus(); ok = ok && cond; };
    verif("societe", !!(R.societe || "").trim());
    verif("nom", !!(R.nom || "").trim());
    verif("email", /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test((R.email || "").trim()));
    return ok;
  }
  const haut = () => racine.querySelector("#carte-q").scrollIntoView({ block: "start", behavior: "smooth" });
  $("#retour").onclick = () => { aller(etape - 1); haut(); };
  $("#suivant").onclick = async () => {
    const nom = ORDRE[etape];
    if (nom === "coordonnees" && !coordonneesValides(true)) return;
    if (nom === "recap") { if (!coordonneesValides(false)) { aller(ORDRE.indexOf("coordonnees")); coordonneesValides(true); return; } await envoyer(); return; }
    aller(etape + 1); haut();
  };
  racine.addEventListener("keydown", e => {
    if (e.key !== "Enter" || e.target.tagName !== "INPUT" || ["checkbox", "file"].includes(e.target.type)) return;
    e.preventDefault();                                  // jamais d'envoi de formulaire involontaire
    if (!e.target.closest("#sp-sur-mesure")) $("#suivant").click();
  });

  // ------------------------------------------------ l'envoi vers le script de reception
  const enBase64 = blob => new Promise((ok, ko) => { const r = new FileReader(); r.onload = () => ok(String(r.result).split(",")[1] || ""); r.onerror = ko; r.readAsDataURL(blob); });
  const identifiant = () => (crypto.randomUUID ? crypto.randomUUID() : Date.now().toString(36) + Math.random().toString(36).slice(2));
  let envoiEnCours = false, idDemande = null;
  async function preparer() {
    const fichiers = [];
    let total = 0;
    const ajouter = async (role, blob, nom, type) => {
      if (!blob || total + blob.size > 22 * 1024 * 1024) return;       // au-dela, l'equipe demandera le fichier par email
      total += blob.size;
      fichiers.push({ role, nom, type: type || blob.type || "application/octet-stream", base64: await enBase64(blob) });
    };
    if (bat.dernier) {
      try { const jpg = await E.composer(bat.dernier.photo, bat.dernier.url, 900); await ajouter("apercu", await (await fetch(jpg)).blob(), "etiquette.jpg", "image/jpeg"); } catch (e) {}
    }
    if (adr.res) {
      try { const X = await chargerXLSX(); await ajouter("destinataires", new Blob([A.versXLSX(adr.res, X)], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), "destinataires-verifies.xlsx"); } catch (e) {}
    }
    if (bat.logoFichier && /^logo/.test(R.etiquetteType || "")) await ajouter("logo", bat.logoFichier, bat.logoNom);
    if (adr.fichier) await ajouter("origine", adr.fichier, adr.nom, adr.fichier.type || "application/octet-stream");
    const reponses = Object.assign({}, R); delete reponses.etape;
    return {
      id: idDemande || (idDemande = identifiant()),
      duree: Math.round((Date.now() - debut) / 1000),
      siteWeb: ($("#sp-site-web") || {}).value || "",
      contact: { societe: R.societe || "", nom: R.nom || "", email: (R.email || "").trim(), telephone: R.telephone || "" },
      reponses,
      resume: resume().map(([, t, v]) => [t, v]).concat(estimation() ? [["Estimation affichée", `${estimation().texte} (${estimation().precision})`]] : []),
      fichiers
    };
  }
  function erreurEnvoi(texte) {
    const z = $("#envoi-erreur");
    const corps = encodeURIComponent(resume().map(([, t, v]) => `${t} : ${v || "Non précisé"}`).join("\n"));
    z.innerHTML = `${texte} <a href="mailto:business@bycharlot.com?subject=${encodeURIComponent("Demande de devis Studio Pro")}&body=${corps}">Envoyer ma demande par email</a>`;
    z.hidden = false;
  }
  // un second essai si le reseau a saute : le script ignore les doublons grace a l'identifiant
  async function poster(corps) {
    let rep = null;
    for (let essai = 0; essai < 2 && !rep; essai++) {
      try {
        const arret = new AbortController(), minuteur = setTimeout(() => arret.abort(), 60000);
        const r = await fetch(DON.reception, { method: "POST", headers: { "Content-Type": "text/plain;charset=utf-8" }, body: corps, signal: arret.signal, redirect: "follow" });
        clearTimeout(minuteur);
        rep = await r.json();
      } catch (e) { rep = null; }
    }
    return rep;
  }
  async function envoyer() {
    if (envoiEnCours) return;                           // un double clic n'envoie pas deux fois
    if (!DON.reception) { erreurEnvoi("L'envoi en ligne n'est pas encore ouvert."); return; }
    envoiEnCours = true; $("#suivant").disabled = true; $("#suivant").textContent = "Envoi…";
    let rep = null;
    try { rep = await poster(JSON.stringify(await preparer())); }
    finally { envoiEnCours = false; $("#suivant").disabled = false; $("#suivant").textContent = "Envoyer ma demande"; }
    if (rep && rep.ok) {
      const prenom = (R.nom || "").trim().split(/\s+/)[0] || "";
      $("#merci-titre").textContent = prenom ? `Merci ${prenom}, nous revenons vers vous.` : "Merci, nous revenons vers vous.";
      R = {}; try { localStorage.removeItem(CLE); } catch (e) {}
      aller(ORDRE.indexOf("merci")); haut();
      return;
    }
    if (rep && rep.erreur === "contact") { aller(ORDRE.indexOf("coordonnees")); coordonneesValides(true); return; }
    if (rep && rep.erreur === "limite") { erreurEnvoi("Vous nous avez déjà envoyé plusieurs demandes dans l'heure. Pour en ajouter une, écrivez-nous :"); return; }
    erreurEnvoi("L'envoi n'a pas abouti, vos réponses sont conservées. Réessayez dans un instant, ou :");
  }

  // ------------------------------------------------ projet sur mesure : un formulaire classique, dans une fenetre
  const fen = $("#sp-sur-mesure");
  if (fen) {
    const ouvrirSurMesure = () => {
      $("#sm-contenu").hidden = false; $("#sm-merci").hidden = true; $("#sm-erreur").hidden = true;
      if (typeof fen.showModal === "function") fen.showModal(); else fen.setAttribute("open", "");
    };
    $$("[data-ouvrir-sur-mesure]").forEach(b => b.addEventListener("click", ouvrirSurMesure));
    // ouverture par l'adresse : les pages voisines (amenagement d'espace) pointent sur #projet-sur-mesure
    const surMesureParAdresse = () => { if (location.hash === "#projet-sur-mesure" && !fen.open) ouvrirSurMesure(); };
    surMesureParAdresse();
    addEventListener("hashchange", surMesureParAdresse);
    fen.addEventListener("click", e => { if (e.target === fen) fen.close(); });   // un clic a cote ferme la fenetre
    let smEnvoi = false, smId = null;
    const v = id => ((racine.querySelector("#" + id) || {}).value || "").trim();
    const erreurSm = texte => {
      const z = $("#sm-erreur");
      const corps = encodeURIComponent(`Société : ${v("sm-societe")}\nContact : ${v("sm-nom")} ${v("sm-telephone")}\n\n${v("sm-projet")}`);
      z.innerHTML = `${texte} <a href="mailto:business@bycharlot.com?subject=${encodeURIComponent("Projet sur mesure")}&body=${corps}">Envoyer par email</a>`;
      z.hidden = false;
    };
    $("#sm-envoyer").onclick = async () => {
      if (smEnvoi) return;
      let ok = true;
      const verif = (id, cond) => { $("#sm-c-" + id).classList.toggle("erreur", !cond); if (!cond && ok) $("#sm-" + id).focus(); ok = ok && cond; };
      verif("societe", !!v("sm-societe")); verif("nom", !!v("sm-nom"));
      verif("email", /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v("sm-email"))); verif("projet", v("sm-projet").length >= 10);
      if (!ok) return;
      if (!DON.reception) { erreurSm("L'envoi en ligne n'est pas encore ouvert."); return; }
      smEnvoi = true; const b = $("#sm-envoyer"); b.disabled = true; b.textContent = "Envoi…";
      const date = v("sm-date");
      const corps = JSON.stringify({
        id: smId || (smId = identifiant()), duree: Math.round((Date.now() - debut) / 1000), siteWeb: v("sm-site-web"), type: "sur-mesure",
        contact: { societe: v("sm-societe"), nom: v("sm-nom"), email: v("sm-email"), telephone: v("sm-telephone") },
        reponses: { quantite: v("sm-quantite"), date },
        resume: [["Type de demande", "Projet sur mesure"], ["Projet", v("sm-projet")], ["Nombre de cadeaux", v("sm-quantite") || "Non précisé"],
                 ["Livraison souhaitée", date ? dateFr(date) : "Non précisée"], ["Contact", [v("sm-societe"), v("sm-nom"), v("sm-email"), v("sm-telephone")].filter(Boolean).join("\n")]],
        fichiers: []
      });
      const rep = await poster(corps);
      smEnvoi = false; b.disabled = false; b.textContent = "Envoyer mon projet";
      if (rep && rep.ok) { $("#sm-contenu").hidden = true; $("#sm-merci").hidden = false; return; }
      if (rep && rep.erreur === "limite") { erreurSm("Vous nous avez déjà écrit plusieurs fois dans l'heure. Pour ajouter un message :"); return; }
      erreurSm("L'envoi n'a pas abouti, votre texte est conservé. Réessayez dans un instant, ou :");
    };
  }

  // un message d'erreur disparait des qu'on corrige le champ
  racine.querySelectorAll(".champ input, .champ textarea").forEach(el => el.addEventListener("input", () => { const c = el.closest(".champ"); if (c) c.classList.remove("erreur"); }));

  // ------------------------------------------------ reprendre ou recommencer
  if (repriseEnCours) $("#reprise").hidden = false;
  $("#recommencer").onclick = () => {
    try { localStorage.removeItem(CLE); } catch (e) {}
    location.hash = "demande";
    location.reload();
  };

  // ------------------------------------------------ demarrage
  rendrePlantes(); majAtelier(); majVitrineTailles(); majLivraison(); apresChoix(); aller(etape);
  if (R.pasDeDate) $("#date").disabled = true;
})();
